module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.props) ? _c('div', {
    staticClass: "divider"
  }, [_c('div', {
    staticClass: "divider__container"
  }, [_vm._m(0), _c('a', {
    staticClass: "divider__phone",
    attrs: {
      "href": _vm.props.acf.phone.href
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.props.acf.phone.label))])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "divider__text"
  }, [_vm._v("we're here for you when you need us even after hours"), _c('br'), _vm._v("Call or text us anytime")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f05bc05e","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/divider/divider.pug
// module id = 735
// module chunks = 1